import * as XLSX from "xlsx";

export function getPruebaRowKey(result, index) {
  const day = result?.testDate ? new Date(result.testDate).toISOString() : `idx-${index}`;
  return `${result?.testName || "test"}::${result?.patientName || "patient"}::${day}::${result?.testTime ?? 0}::${index}`;
}

function formatDateExcel(dateStr) {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleString("es-MX", {
    dateStyle: "short",
    timeStyle: "short",
  });
}

function formatDuration(seconds) {
  if (seconds == null || seconds === undefined) return "";
  const total = Number(seconds);
  if (Number.isNaN(total)) return "";
  const hours = Math.floor(total / 3600);
  const minutes = Math.floor((total % 3600) / 60);
  const secs = Math.floor(total % 60);
  return [hours, minutes, secs].map((value) => String(value).padStart(2, "0")).join(":");
}

function sanitizeFilePart(value) {
  return String(value || "prueba")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-zA-Z0-9_-]+/g, "_")
    .replace(/^_+|_+$/g, "")
    .slice(0, 40) || "prueba";
}

/**
 * Exporta resultados de la vista Pruebas a Excel.
 * @param {{ testName: string, results: Array }} params
 */
export function downloadPruebasExcel({ testName, results }) {
  if (!results?.length) return;

  const label = testName || results[0]?.testName || "Prueba";

  const resumenRows = results.map((result) => ({
    Paciente: result.patientName || "",
    Sexo: result.gender || "",
    Edad: result.age ?? "",
    Prueba: label,
    Fecha: formatDateExcel(result.testDate),
    Duración: formatDuration(result.testTime),
    Puntuación: result.testResultNumber ?? "",
    Porcentaje:
      result.testResultPercentage != null && result.testResultPercentage !== ""
        ? `${result.testResultPercentage}%`
        : "",
  }));

  const detalleRows = [];
  results.forEach((result) => {
    (result.resultsList || []).forEach((item) => {
      detalleRows.push({
        Paciente: result.patientName || "",
        Prueba: label,
        "Fecha sesión": formatDateExcel(result.testDate),
        "Pregunta #": item.indexselected ?? "",
        Respuesta: item.textselected ?? "",
        Valor: item.valueselected ?? "",
      });
    });
  });

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(
    workbook,
    XLSX.utils.json_to_sheet(resumenRows),
    "Resumen"
  );
  XLSX.utils.book_append_sheet(
    workbook,
    XLSX.utils.json_to_sheet(
      detalleRows.length
        ? detalleRows
        : [{ Nota: "Sin detalle de respuestas en las pruebas seleccionadas" }]
    ),
    "Detalle respuestas"
  );

  const date = new Date().toISOString().slice(0, 10);
  const testPart = sanitizeFilePart(label);
  XLSX.writeFile(workbook, `${testPart}_${results.length}_pruebas_${date}.xlsx`);
}
